module.exports = __webpack_public_path__ + "img/onboarding-icon.2fc1d410.svg";